// TransferPayment.js
import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

function TransferPayment() {
  // Bank transfer payment UI elements and logic 
  return (
    <>
      <div className="py-2 d-flex justify-content-center">
        <h2 className="text-center py-2">Transfer</h2>
        <div>Coming soon...</div>
      </div>
    </>
  );
}

export default TransferPayment;
